module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/13z5g8O/images/cover.jpg?1711065641291",
      "alt": "This image is the cover for the book Joyful Stitching"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Joyful Stitching\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Stitch playful projects  Dive into Laura’s delightful world of embroidery and learn how to create small, free-form embroidery pieces that are alive with color and texture. With instructions for 21 basic embroidery stitches and 6 projects, all in Laura’s signature colorful, whimsical style, you’ll transform a flat, plain surface into a joyful, design-packed art piece. Stitch on wool, felt, or silk, and enjoy the simple pleasure of slow stitching. Includes a gallery of display ideas, as well as additional ideas for using free-form stitching.  • Begin with simple shapes and fill them with improvisational stitchery • Change up the provided designs, swapping out colors and trying new stitch combinations, to create your own unique work • From popular, best-selling author and teacher Laura Wasilowski")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Laura Wasilowski\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing, Inc\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0